var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiVeryDissatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_01-Confounded_Face",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "01-Confounded Face",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 1.304,
    y2: 63.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99306"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 18.33,
    x2: 45.67,
    y1: 36.47,
    y2: 36.47
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b4b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#d0ccc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#f2edea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#f9f5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#e8e5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1d1"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 47.038,
    y2: 35.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69101b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#400a10"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 63c-27.7 0-31.038-24-31-30v-2c-.038-6 3.3-30 31-30 27.7 0 31.038 24 31 30v2c.038 6-3.3 30-31 30z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m45.67 38.94a83.518 83.518 0 0 0 -13.67-.94 83.518 83.518 0 0 0 -13.67.94c2.4-2.65 6.54-4.94 13.67-4.94s11.27 2.29 13.67 4.94z",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.94 48.87a46.368 46.368 0 0 0 -17.88 0c.38-.79 2.62-4.87 8.94-4.87s8.56 4.08 8.94 4.87z",
    fill: "#8f030e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m49 47a3 3 0 0 1 -3 3h-.48a2.83 2.83 0 0 1 -.95-.16 28.86 28.86 0 0 0 -3.63-.96v-.01c-.38-.79-2.62-4.87-8.94-4.87s-8.56 4.08-8.94 4.87v.01a28.86 28.86 0 0 0 -3.63.96 2.83 2.83 0 0 1 -.95.16h-.48a3 3 0 0 1 -3-3 13.114 13.114 0 0 1 2.12-6.5 11.947 11.947 0 0 1 1.21-1.56 83.518 83.518 0 0 1 13.67-.94 83.518 83.518 0 0 1 13.67.94 13.141 13.141 0 0 1 3.33 8.06z",
    fill: "url(#linear-gradient-3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.9 12.6c-.5-.669-1.035-1.317-1.589-1.926l1.478-1.347c.6.656 1.174 1.355 1.713 2.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.318 53.636c-7.189-8.729-7.326-19.449-7.318-20.643v-1.993c-.033-4.954 1.83-15.28 9.022-22.521 5.589-5.626 13.32-8.479 22.978-8.479 8.912 0 16.2 2.439 21.672 7.249l-1.321 1.5c-5.093-4.478-11.94-6.749-20.351-6.749-9.1 0-16.359 2.654-21.559 7.889-6.729 6.774-8.472 16.453-8.441 21.104v2.007a32.589 32.589 0 0 0 6.862 19.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 64c-9.5 0-17.132-2.76-22.7-8.2l1.4-1.43c5.179 5.062 12.346 7.63 21.3 7.63 9.1 0 16.359-2.654 21.559-7.889 6.729-6.774 8.472-16.453 8.441-21.1v-2.121a33.495 33.495 0 0 0 -4.789-16.362l1.7-1.056a35.481 35.481 0 0 1 5.089 17.418v2.11c.033 4.954-1.83 15.28-9.022 22.521-5.589 5.626-13.32 8.479-22.978 8.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51 14c-11.486 0-14.761-6.285-14.9-6.553l1.786-.9c.12.223 2.945 5.453 13.114 5.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 14v-2c10.169 0 12.994-5.23 13.109-5.454l1.786.9c-.134.269-3.409 6.554-14.895 6.554z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.757 30.97c-.31-.077-7.622-1.943-10.243-5.825a2.038 2.038 0 0 1 0-2.29c2.62-3.882 9.932-5.748 10.242-5.825l.486 1.94c-.069.017-6.879 1.758-9.071 5.005 1.823 2.751 7.166 4.579 9.071 5.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.243 30.97-.486-1.94c.069-.017 6.879-1.758 9.071-5.005-1.823-2.751-7.166-4.579-9.071-5.055l.486-1.94c.31.077 7.622 1.943 10.243 5.825a2.038 2.038 0 0 1 0 2.29c-2.621 3.882-9.933 5.748-10.243 5.825z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 51h-.48a3.822 3.822 0 0 1 -1.286-.218 27.978 27.978 0 0 0 -3.492-.922l.4-1.96a29.617 29.617 0 0 1 3.758 1 1.846 1.846 0 0 0 .624.1h.476a2 2 0 0 0 2-2 12.262 12.262 0 0 0 -3.072-7.389c-2.77-3.06-7.12-4.611-12.928-4.611s-10.158 1.551-12.929 4.611a10.918 10.918 0 0 0 -1.114 1.436 12.253 12.253 0 0 0 -1.957 5.953 2 2 0 0 0 2 2h.48a1.829 1.829 0 0 0 .615-.1 29.653 29.653 0 0 1 3.767-1l.4 1.96a28.093 28.093 0 0 0 -3.5.925 3.794 3.794 0 0 1 -1.282.215h-.48a4 4 0 0 1 -4-4 14.064 14.064 0 0 1 2.283-7.046 12.931 12.931 0 0 1 1.317-1.692c3.155-3.49 8-5.262 14.4-5.262s11.245 1.772 14.411 5.269a14.082 14.082 0 0 1 3.589 8.731 4 4 0 0 1 -4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.74 49.85a45.569 45.569 0 0 0 -17.48 0l-.4-1.96a47.561 47.561 0 0 1 18.28 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.1 49.447-.06-.12c-.014-.03-.027-.06-.04-.091-.423-.85-2.478-4.236-8-4.236s-7.583 3.4-8.007 4.24c-.012.03-.024.059-.038.087l-.06.12-1.135-.567h-.7a1.086 1.086 0 0 1 .051-.324h-.006l.024-.047a.717.717 0 0 1 .03-.069c.441-.911 2.963-5.44 9.841-5.44s9.405 4.529 9.841 5.437a.636.636 0 0 1 .031.071l.023.045h-.006a.984.984 0 0 1 .051.314l-.694.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.821 39.984-.33-.06a82.772 82.772 0 0 0 -13.491-.924 82.767 82.767 0 0 0 -13.5.925l-.324.059-.358-1.968.33-.06a83.8 83.8 0 0 1 13.852-.956 83.8 83.8 0 0 1 13.843.955l.336.061z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVeryDissatisfied);
export default __webpack_public_path__ + "static/media/emojiVeryDissatisfied.57bea83491c0c496e061b66727cb233d.svg";
export { ForwardRef as ReactComponent };